module.exports = __webpack_public_path__ + "img/FPT20.c9b656e0.svg";